const state = {
  cms: {},
  notification: {},
  regions: [],
  selectedRegion: {},
  selectedObservation: {},
  forecasts: [],
  recaptcha: '',
  observations: [],
  observationsFilters: {},
  showRecentPublicObs: true,
};

export default state;
